export default __webpack_public_path__ + "static/media/bitbucket.090f9172.png";